module.exports = __webpack_public_path__ + "7eef48aee664525b31585074f3a012d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/building-regular.svg
// module id = 667
// module chunks = 0